module.exports = __webpack_public_path__ + "img/win.acf0ca19.png";